var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.isPc ? 'online-num-contain-pc' : 'online-num-contain']},[_c('div',{staticClass:"left-p"},[_c('van-icon',{attrs:{"name":"friends"}})],1),_c('div',{staticClass:"right-p"},[_vm._v(_vm._s(_vm.people))])])
}
var staticRenderFns = []

export { render, staticRenderFns }